import { SUITE } from "../../common/apiUrl/suite/suiteUrls";
import { API } from "../../common/model/objectTypes";
import { clientManagementInfo } from "../../utils/apiDescription/suite/clientManagement";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { addClientRequestBody, clientUploadCSVRequestBody, deleteClientRequestParameter, editClientRequestBody, getAllClientsRequestParameter, getAllClientsResponseBody } from "../../utils/suite/apiObjects";
import { addClientRequestCurl, ClientUploadCsvRequestCurl, deleteClientJsonRequestCurl, editClientRequestCurl, getAllClientsJsonRequestCurl } from "../../utils/suite/sampleJsonRequest";
import { getAllClientsJsonResponse } from "../../utils/suite/sampleJsonResponse";

const AddClient: API = {
    name: "Add Client",
    url: `${API_BASE_URL}/${SUITE.CLIENT_MANAGEMENT.ADD_CLIENT_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: clientManagementInfo.addClient,
    requestBody: addClientRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: addClientRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const All: API = {
    name: "All clients",
    url: `${API_BASE_URL}/${SUITE.CLIENT_MANAGEMENT.ALL_CLIENTS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: clientManagementInfo.allClients,
    requestBody: getAllClientsRequestParameter,
    responseBody: getAllClientsResponseBody,
    jsonRequest: getAllClientsJsonRequestCurl,
    jsonResponse: getAllClientsJsonResponse,
}

const DeleteClient: API = {
    name: "Delete client",
    url: `${API_BASE_URL}/${SUITE.CLIENT_MANAGEMENT.DELETE_CLIENT_URL}`,
    method: "DEL",
    headers: commonRequestHeader,
    apiInfo: clientManagementInfo.deleteClient,
    requestBody: deleteClientRequestParameter,
    responseBody: commonResponseBody,
    jsonRequest: deleteClientJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const EditClient: API = {
    name: "Edit client",
    url: `${API_BASE_URL}/${SUITE.CLIENT_MANAGEMENT.EDIT_CLIENT_URL}`,
    method: "PUT",
    headers: commonRequestHeader,
    apiInfo: clientManagementInfo.editClient,
    requestBody: editClientRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: editClientRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const UploadClientCSV: API = {
    name: "Upload client CSV",
    url: `${API_BASE_URL}/${SUITE.CLIENT_MANAGEMENT.UPLOAD_CLIENT_CSV_URL}`,
    method: "POST",
    headers: requestHeaderWithCallback,
    apiInfo: clientManagementInfo.uploadClientCSV,
    requestBody: clientUploadCSVRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: ClientUploadCsvRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'All':
            return All;
        case 'Add Client':
            return AddClient;
        case 'Delete Client':
            return DeleteClient;
        case 'Edit Client':
            return EditClient;
        case 'Upload client CSV':
            return UploadClientCSV;
    }
}